import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL;

const OrganizationPageAdmin = () => {
  const [organizations, setOrganizations] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  
  useEffect(() => {
    // Fetch pending organizations when the component is mounted
    axios
      .get(`${API_URL}/organization/pending/`)
      .then((response) => {
        setOrganizations(response.data.organizations);
      })
      .catch((err) => {
        console.error("Error fetching pending organizations", err);
      });
  }, []);

  const handleApprove = (orgId) => {
    axios
      .post(`${API_URL}/organization/approve/`, { org_id: orgId }) // Send org_id in the body
      .then((response) => {
        setSnackbarMessage('Organization approved successfully!');
        setOpenSnackbar(true);
        setOrganizations((prev) => prev.filter((org) => org.id !== orgId));
      })
      .catch((err) => {
        setSnackbarMessage('Error approving organization.');
        setOpenSnackbar(true);
      });
  };

  const handleReject = (orgId) => {
    axios
      .post(`${API_URL}/organization/reject/`, { org_id: orgId }) // Send org_id in the body
      .then((response) => {
        setSnackbarMessage('Organization rejected.');
        setOpenSnackbar(true);
        setOrganizations((prev) => prev.filter((org) => org.id !== orgId));
      })
      .catch((err) => {
        setSnackbarMessage('Error rejecting organization.');
        setOpenSnackbar(true);
      });
  };

  // Function to format the date-time in a readable format
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString(); // Format the date to a readable string
  };

  return (
    <div>
      <h1>Pending Organizations</h1>
      <div>
        {organizations.length === 0 ? (
          <p>No pending organizations.</p>
        ) : (
          organizations.map((org) => (
            <div key={org.id} style={{ marginBottom: '20px', border: '1px solid #ddd', padding: '10px', borderRadius: '8px' }}>
              <h3>{org.name}</h3>
              <p><strong>User:</strong> <Link to={`/user-profile-admin-view/${org.org_user_id}`} style={{ textDecoration: "none" }}>{org.user_name}</Link></p>
              <p><strong>Industry Type:</strong> {org.industry_type}</p>
              <p><strong>About:</strong> {org.about}</p>
              <p><strong>Website:</strong> <a href={org.website} target="_blank" rel="noopener noreferrer">{org.website}</a></p>
              <p><strong>Location:</strong> <a href={org.location_google_maps_link} target="_blank" rel="noopener noreferrer">{org.location_google_maps_link}</a></p>
              <p><strong>Status:</strong> {org.status}</p>
              <p><strong>Created At:</strong> {formatDate(org.created_at)}</p>
              <p><strong>Updated At:</strong> {formatDate(org.updated_at)}</p>
              <div>
                {org.logo && (
                  <img src={`${API_URL}${org.logo}`} alt={`${org.name} logo`} style={{ maxWidth: '100px', marginBottom: '10px' }} />
                )}
              </div>
              <button onClick={() => handleApprove(org.id)} style={{ marginRight: '10px', padding: '5px 10px', backgroundColor: 'green', color: 'white', border: 'none', borderRadius: '4px' }}>Approve</button>
              <button onClick={() => handleReject(org.id)} style={{ padding: '5px 10px', backgroundColor: 'red', color: 'white', border: 'none', borderRadius: '4px' }}>Reject</button>
            </div>
          ))
        )}
      </div>
      {openSnackbar && (
        <div style={{ position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#333', color: '#fff', padding: '10px', borderRadius: '4px' }}>
          {snackbarMessage}
        </div>
      )}
    </div>
  );
};

export default OrganizationPageAdmin;
